import { List, Card, Divider, Button, Tag } from "antd"
import axios from "axios"
import { useContext, useState } from "react"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { ThemeContext } from "../Context/ThemeContext"


const GridProducts = () => {
    const [listOfProduct, setListOfProduct] = useState([]);
    const [loading, setLoading] = useState(false)
    const [theme] = useContext(ThemeContext)
    const history = useHistory()

    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''

    const HandleSeeMore = () => {
        history.push("/product")
    }

    const products = async () => {
        setLoading(true)
        const result = await axios.get("https://backend-sportyan.vercel.app/api/products")
         .then((res)=> res.data)
         .catch((err) => {
             console.log(err)
         })
         const newListProduct = result.slice(0,10)
         setListOfProduct(newListProduct)
         setLoading(false)
    }
    
    useEffect(() => {
        products()
    }, [])

    const HandleDetail = async (event) => {
        let idProduct = Number(event.target.value)

        history.push(`/product/detail/${idProduct}`)
    }

    // console.log(listOfProduct[1].category[1].category.name)
    
    return (
        <div style={{marginTop: "100px"}}>
            <Divider className={changeNameClass} orientation="center" style={{fontSize: "30px", marginBottom: "60px"}}>
               OUR PRODUCTS
            </Divider>
            <List 
            loading={loading}
            grid = {{column: 5}}
            dataSource={listOfProduct}
            renderItem={el => (
            
                <List.Item>
                <Card className={changeNameClass} key={el.id} style={{boxShadow: "3px 3px 1px 1px #009FB7", borderRadius: "20px", height: "425px", width:"225px"}}
                cover={<img src={el.image} alt="banner-products" style={{width: "100%", height: "auto", color: "#272727", borderRadius: "20px 20px 0px 0px"}}/>}>
                <div className={changeNameClass + " card"}>
                {el.category.map(function(item){
                    return (
                    <Tag color="#f50" style={{margin: "5px 2px 0px 0px", height: "22px"}}>
                        <p style={{fontSize: "12px", color:"white"}}>{item.category.name}</p>
                    </Tag>)})}
                    <h1 style={{marginTop: "5px"}}>{el.name}</h1>
                    <h3>Rp.{el.price}</h3>
                </div>
                    <button className="button-7" onClick={HandleDetail} value={el.id} >Detail</button>
                </Card>
            </List.Item>
            
            )}
            />
            <div className="center">
                <Button style={{margin: "30px auto", background: "#009FB7"}} type="primary" size="large" onClick={HandleSeeMore}>See More</Button>
            </div>
        </div>
        
    )
}

export default GridProducts